import * as React from 'react';
import Tooltip from './Tooltip';
class TooltipComponent extends React.Component {
    constructor() {
        super(...arguments);
        this.setRef = e => {
            this.comp = e;
        };
    }
    show() {
        this.comp.getWrappedInstance().show();
    }
    hide() {
        this.comp.getWrappedInstance().hide();
    }
    render() {
        return <Tooltip ref={this.setRef} {...this.props}/>;
    }
}
export default TooltipComponent;
